import { Component, Input } from '@angular/core';
import { IClient } from '@internal-models/client.model';
import { InternalNavigationType } from '@shared-directives/navigate.directive';
import { NavigationDataKey, UserPermissions } from '@shared-libs/enums';

@Component({
	selector: 'client-details-component',
	templateUrl: 'client-details.component.html',
	styleUrls: ['./client-details.component.scss'],
})
export class ClientDetailsComponent {
	@Input() public client: Partial<IClient>;
	@Input() public type: 'info-line' | 'basic' = 'info-line';
	@Input() public clientNavigationEnabled: boolean = true;

	public readonly InternalNavigationType: typeof InternalNavigationType = InternalNavigationType;
	public readonly NavigationDataKey: typeof NavigationDataKey = NavigationDataKey;
	public readonly UserPermissions: typeof UserPermissions = UserPermissions;
}
